import { tv } from "@ui/lib/tv";

/** Shared shell for the SearchBar's trailing pill controls (Filters, Sort): a white,
 *  rounded-full button with a 1px neutral keyline matching the search bar. Consumers add
 *  their own leading margin / width (e.g. `ml-4`, `w-24`) via `className`. */
export const searchBarPillButton = tv({
  base: [
    "flex h-10 shrink-0 cursor-pointer items-center justify-center gap-2 rounded-full bg-white px-3 py-2 outline-none",
    "shadow-keyline",
    "hover:bg-neutral-50",
    "data-[pressed]:bg-neutral-100",
    "focus-visible:ring-2 focus-visible:ring-neutral-300",
  ],
  slots: {
    icon: "shrink-0 text-neutral-600 [&>svg]:size-5",
    label: "text-base font-semibold tracking-[-0.16px] text-neutral-600",
  },
});
